import { Vehicle } from '@esportal/portal-service';
import React from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { formatOwnership } from '../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../tracking/useTrackingManager';

export const useNotificationsTracker = () => {
	const sectionName = 'Notificaciones';
	const trackingManager = useTrackingManager();
	// User vehicles
	const { portalService } = React.useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const trackOpenLayerClick = () => {
		const contentIdValue = `${sectionName} - Open Layer`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	const trackLayerLoad = React.useCallback(() => {
		trackingManager.trackClubVWLayerLoad(
			{ contentId: sectionName },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	}, [trackingManager, userVehicles]);

	const trackLayerCloseClick = () => {
		trackingManager.trackClubVWLayerCloseClick(sectionName, { contentId: sectionName });
	};

	const trackNotificationClick = (notificationTag?: string, vehicle?: Vehicle) => {
		const contentIdValue = `${sectionName} - ${notificationTag}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(vehicle ? [vehicle] : []) },
		);
	};

	return {
		trackOpenLayerClick,
		trackLayerLoad,
		trackLayerCloseClick,
		trackNotificationClick,
	};
};
